import Tween from "tween.ts";
import Animation from "./Animation";
import Firework from "../entities/firework/FireworkController";


export default class WinAnimation extends Animation {
  winningFirework: Firework;
  animation;
  constructor(winningFirework: Firework) {
    super()
    this.winningFirework = winningFirework;

    const nWidth = winningFirework.width * 1.1;
    const nHeight = winningFirework.height * 1.1;

    this.animation = new Tween.Tween(winningFirework)
      .to({
        width: nWidth,
        height: nHeight
      }, 800)
      .easing(Tween.Easing.Quadratic.InOut)
      .repeat(Infinity)
      .yoyo(true)
  }
  start() {
    this.animation.start();
  }
  stop() {
    this.animation.stop();
  }
}